module.exports = __webpack_public_path__ + "static/media/icon_phone.dc4eb3f9.svg";